Ext.define('SA.InertArrowExportMenu', {
    alias: 'widget.inert-arrow-export-menu',
    extend: 'SA.view.ArrowMenu',

    alignment: 'bottom',
    autoShow: true,
    behaveAsWindow: true,
    closeAction: 'hide',
    cls: 'sa-inert-arrow-export-menu',
    ignoreTargetMouseDown: true
});